<app-spinner-overlay
    [showSpinner]="isAddingCharge"
    xmlns="http://www.w3.org/1999/html">
</app-spinner-overlay>
<div class="modal-header">
    <h4 class="fw-semibold mb-0">
        @if (chargeType === 'cancellationCharge') {
            Add Cancellation Charge
        } @else if (chargeType === 'depositCharge') {
            Add Deposit Charge
        } @else if (booking.pendingCancellationCharge !== null) {
            Edit Cancellation Charge
        } @else if (booking.pendingDepositCharge !== null) {
            Edit Deposit Charge
        }
    </h4>
    <button
        type="button"
        class="btn btn-close"
        (click)="dismiss()"
    >
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="form" class="vstack gap-3">
        @if (chargeType === 'depositCharge') {
            <div class="vstack gap-2">
                @if (canSendLinks) {
                    <label class="form-label">
                        How will the deposit be collected?
                    </label>
                    <div
                        class="d-flex btn-group segmented-control justify-content-evenly"
                        role="group"
                    >
                        <input
                            type="radio"
                            class="btn-check"
                            id="sendLink"
                            autocomplete="off"
                            [value]="false"
                            formControlName="paidInPerson"
                        >
                        <label
                            class="btn btn-outline-primary text-nowrap"
                            for="sendLink"
                            (click)="form.get('paidInPerson')?.setValue(false)"
                        >
                            Send Link to Pay
                        </label>
                        <input
                            type="radio"
                            class="btn-check"
                            id="manualPayment"
                            autocomplete="off"
                            [value]="true"
                            formControlName="paidInPerson"
                        >
                        <label
                            class="btn btn-outline-primary text-nowrap"
                            for="manualPayment"
                            (click)="form.get('paidInPerson')?.setValue(true)"
                        >
                            In-Person Payment
                        </label>
                    </div>
                }
            </div>
        }
        @if (chargeType === 'depositCharge' && form.get('paidInPerson')?.value) {
            <div class="vstack gap-2">
                <div class="vstack">
                    <div class="hstack justify-content-between">
                        <label class="me-auto text-nowrap">
                            Mark as Paid Immediately
                        </label>
                        <div class="form-check form-switch">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                id="payNowSwitch"
                                role="switch"
                                formControlName="isPaidImmediately"
                            >
                        </div>
                    </div>
                    <span class="form-text">
                        Enable if the deposit is being paid right now in person, otherwise it will be marked as pending until you mark it as paid.
                    </span>
                </div>
            </div>
        }
        <app-edit-charge-form
            [chargeType]="chargeType"
            [partySize]="booking.size"
            [(charge)]="charge"
            [previousExpiryDate]="previousExpiryDate"
            [expiryMinutes]="expiryMinutes"
            [showExpiryTime]="showExpiryTime"
            [amountOnly]="amountOnly"
            (expiryMinutesChange)="expiryMinutesChanged($event)"
        >
            <div
                charge-summary
                class="bg-body-tertiary border border-light rounded-3 p-3"
            >
                <div class="vstack gap-2">
                    <span class="fw-semibold fs-6">
                        @if (charge !== null) {
                            {{ null | currencyUnit : charge.amount : 'GBP' }}
                            @if (charge.isPerCover) {
                                ({{ null | currencyUnit : charge.unitAmount : 'GBP' }}
                                x
                                {{ booking.size }})
                            }
                        } @else {
                            No Charge
                        }
                    </span>
                    <hr class="my-1"/>
                    <span
                        class="px-1"
                        *ngIf="showExpiryDate"
                    >
                        Booking will be cancelled if the link expires, at
                        <span class="fw-semibold">
                            {{ expiryDate | date: 'short' }}
                        </span>
                    </span>
                    <span
                        class="px-1"
                        *ngIf="!showExpiryDate && !isPaidInPerson"
                    >
                        Link will never expire
                    </span>
                    @if (isPaidInPerson && isPaidImmediately) {
                        <span class="px-1">
                            Deposit will be marked as paid in person immediately
                        </span>
                    } @else if (isPaidInPerson && !isPaidImmediately) {
                        <span class="px-1">
                            Deposit will be marked as pending (to be paid in person later)
                        </span>
                    }
                </div>
            </div>
        </app-edit-charge-form>
        @if (showDeliveryMethods) {
            <hr class="my-0"/>
            <div class="vstack gap-2">
                <label
                    class="form-label m-0 fw-semibold"
                >
                    Send to:
                </label>
                <div class="vstack gap-2 align-content-stretch">
                    <label
                        class="btn btn-outline-secondary p-2 d-flex flex-column justify-content-center align-items-center"
                        [class.disabled]="booking.emailAddress === null"
                    >
                        <div class="m-1 hstack gap-2">
                            <input
                                type="radio"
                                [value]="'email'"
                                formControlName="linkDeliveryMethod"
                                class="form-check-input m-0"
                                role="button"
                            >
                            <div class="vstack align-items-start">
                            <span
                                *ngIf="booking.emailAddress !== null"
                                class="fw-semibold"
                            >
                                Email: {{ booking.emailAddress }}
                            </span>
                                <span
                                    *ngIf="booking.emailAddress === null"
                                    class="fw-normal"
                                >
                                Email: Email address not provided
                            </span>
                            </div>
                        </div>
                    </label>
                    <label
                        class="btn btn-outline-secondary p-2 d-flex flex-column justify-content-center align-items-center"
                        [class.disabled]="booking.phoneNumber === null"
                    >
                        <div class="m-1 hstack gap-2">
                            <input
                                type="radio"
                                [value]="'sms'"
                                formControlName="linkDeliveryMethod"
                                class="form-check-input m-0"
                                role="button"
                            >
                            <div class="vstack align-items-start">
                            <span
                                *ngIf="booking.phoneNumber !== null"
                                class="fw-semibold"
                            >
                                SMS: {{ booking.phoneNumber | phoneNumber }}
                            </span>
                                <span
                                    *ngIf="booking.phoneNumber === null"
                                    class="fw-normal"
                                >
                                SMS: Phone number not provided
                            </span>
                            </div>
                        </div>
                    </label>
                </div>
            </div>
        }
    </form>
</div>
<div
    class="modal-footer"
>
    <button
        type="button"
        class="btn btn-outline-secondary"
        (click)="dismiss()"
    >
        Cancel
    </button>
    <button
        type="button"
        class="btn btn-primary"
        [disabled]="form.invalid || charge === null"
        (click)="save()"
    >
        {{ buttonText }}
    </button>
</div>
